import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import classnames from 'classnames';
import APIs from '@services/APIs';
import Header from '@lib/components/v2/Page/Header';
import { localizedString, isLocalizedStringDefined } from '@languages';

import { useLogo } from '@js/hooks/useLogo';
import './Success.style.scss';

const Success = ({ successMessage, redirect = false }) => {
  document.body.style.background = '#fff';
  const finalLogo = useLogo({ isSuccessScreen: true });

  const handleRedirect = () => {
    if (redirect) {
      APIs.return();
    }
  };

  let successMessageTitle = parse(localizedString('verificationComplete.title'));

  if (redirect && isLocalizedStringDefined('verificationComplete.titleRedirect')) {
    successMessageTitle = parse(localizedString('verificationComplete.titleRedirect'));
  }

  if (successMessage) {
    successMessageTitle = parse(successMessage);
  }

  return (
    <div className="success-flowv2-screen">
      <div className="feedback-link-container-success">
        <Header hideLogo />
      </div>

      <div className="wrapper">
        <div className="img-container" data-testid="cmplt-logo">
          <img alt="" src={finalLogo} />
        </div>
        <div className={classnames({ heading: !successMessage })} data-testid="cmplt-heading">
          {successMessageTitle}
        </div>
        <div className="title" onClick={handleRedirect} data-testid="cmplt-instruction">
          {redirect
            ? parse(localizedString('verificationComplete.redirectedDescription'))
            : parse(localizedString('verificationComplete.youCanCloseThisWindow'))}
        </div>
      </div>
    </div>
  );
};
Success.propTypes = {
  successMessage: PropTypes.any,
  redirect: PropTypes.bool
};
export default Success;
